import React from "react";
import VideoSectionComponent from "../icon/VideoSection";
import {Element} from "react-scroll";


const RecommendTable: React.FC<{ content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean }> = ({ content, defaultTemplate }) => {
    const img1 = "/assets/images/1.jpg";
    const img2 = "/assets/images/2.jpg";
    const img3 = "/assets/images/3.jpg";
    const img4 = "/assets/images/4.jpg";
    const img5 = "/assets/images/5.jpg";
    const img6 = "/assets/images/6.jpg";
    const img7 = "/assets/images/7.jpg";
    const img8 = "/assets/images/8.jpg";
    const img9 = "/assets/images/9.jpg";
    const img10 = "/assets/images/10.jpg";

    return (
        <>
            <Element name="recommended">
                <div className={"div-section"} style={{marginTop: '48px'}}>
                    <div style={{height: '40px'}}>
                        <span className="title-section">
                            {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : 'おすすめコンテンツ' : 'おすすめコンテンツ' }
                        </span>
                    </div>

                    <div className={"border-title"}>
                        <div className={"underline-title-recommended"}></div>
                    </div>

                    <div style={{marginTop: '16px'}}>
                        {
                            content?.TEXT?.[0]
                        }
                    </div>

                    {
                        (content?.TABLE?.[0] || defaultTemplate) &&
                        <table className={"table-advice-style"} style={{fontFamily: '源ノ角ゴシック JP', marginTop: '24px'}}>
                            <thead>
                            <tr>
                                <th style={{ width: '35%' }} className={'p-4'}>コンテンツ名 (視聴時間)</th>
                                <th className={'p-4'}>解説</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'イントロダクション'}
                                        duration={'24:19'}
                                        imageUrl={img1}
                                        urlContent={'https://player.aircamp.us/content/57180?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> これからの時代に必要な「リスキリングの10のスキル」として、変革型・安定型の4つのキャリアタイプ（リーダー・イノベーター・スペシャリスト・コーチ）に応じた成長戦略を紹介。ブラックキャリアとホワイトキャリアの違いや、自我の確立の重要性にも触れ、自分らしいキャリアを築くための実践的なヒントを提供します。キャリアに悩むすべてのビジネスパーソン必見の内容です。
                                    <br/> <br/>キーワード：リスキリング、ホワイトキャリア、自我の確立
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'①自己を明確に理解するスキル'}
                                        duration={'13:30'}
                                        imageUrl={img2}
                                        urlContent={'https://player.aircamp.us/content/57181?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> リスキリングを成功させるための鍵となる「自己認識スキル」について自尊と共感を中心に、傲慢との違いや「私的・公的自己認識」の理解について解説します。自己理解を深めるためには、事実ベースのセルフインタビューを行うことで安定した自尊感情を築き、他者との健全な関係性や期待にも応えられる力が養われます。実践的な振り返りの方法を学ぶことができます。
                                    <br/><br/>キーワード：自尊、共感、セルフインタビュー
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'②状況を整理して把握するスキル'}
                                        duration={'18:20'}
                                        imageUrl={img3}
                                        urlContent={'https://player.aircamp.us/content/57182?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> ビジネスパーソンがリスキリングする上で不可欠な「状況を整理して把握するスキル」に焦点を当て、メタ認知力の重要性や認知の歪みを防ぐための具体的な方法を紹介します。フレーミング効果やプロスペクト理論など、心理的バイアスへの対処法も解説しながら、状況認知を通じて成果を最大化するための思考プロセスを体系的に学べます。認知を見直すことで、より的確な意思決定ができるようになるヒントが満載です。
                                    <br/><br/>キーワード：メタ認知、フレーミング効果、認知の歪み
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'③専門性を活かすスキル'}
                                        duration={'16:00'}
                                        imageUrl={img4}
                                        urlContent={'https://player.aircamp.us/content/57183?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 専門性を単なる知識や資格として持つだけでなく、「プロフェッショナリズム」や「コンピテンシー」を通じて成果につなげる力の重要性を解説しています。知識を応用し、自律的に価値を創出する“プロフェッショナル”になるための考え方やスキルレベルの違い、そして専門性の実践的活用法について具体例を交えて学べます。
                                    <br/><br/>キーワード：プロフェッショナリズム、コンピテンシー
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'④相手を理解するスキル'}
                                        duration={'15:30'}
                                        imageUrl={img5}
                                        urlContent={'https://player.aircamp.us/content/57184?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 相手を深く理解するために重要なのが「アクティブリスニング（能動的傾聴）」です。ただうなずいて話を聞くのではなく、質問や繰り返し、明確化といった技法を使い、相手の本音や真意を引き出します。評価や意見を挟まず、相手の伝えたいことを正確に受け取る「需要的コミュニケーション」の姿勢が、信頼関係の構築と誤解の回避につながることが解説されています。
                                    <br/><br/>キーワード：アクティブリスニング、質問技法
                                </td>
                            </tr><tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑤他者を活躍させるスキル'}
                                        duration={'24:19'}
                                        imageUrl={img6}
                                        urlContent={'https://player.aircamp.us/content/57185?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 他者を活躍させるために必要な「エンカレッジメント（勇気づけ）」について解説します。相手が自らの意思で行動できるように促すためには、評価的な視点を排除し、褒める・叱るのではなく、感想として自分の思いを伝えることが大切です。また、多様性のある組織では、演技的にでも「水平関係」を演出することで、対等な関係を築くことが重要とされています。相手の主体性を尊重したコミュニケーションの本質を学べる内容です。
                                    <br/><br/>キーワード：エンカレッジメント、水平関係と垂直関係、感想の伝え方
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑥状況を前向きに認知するスキル'}
                                        duration={'24:19'}
                                        imageUrl={img7}
                                        urlContent={'https://player.aircamp.us/content/57186?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 前向きさを維持するには、「自己効力感」が鍵になる。この講義では満足感と幸福感について判断も行動も迅速で、常に明るく、周囲の信頼を集める人たちが持っているスキルだ。高めるためには、最終成果イメージに基づいた目標設定力や他人のよい行動をまねるモデリング効果、ポジティブな言動等が有効だ。胃が痛いなどのストレス反応に対して我慢や逃避ではなく、原因となるストレッサーを特定し対策を講じていくストレスマネジメントも欠かせない。
                                    <br/><br/>キーワード：自己効力感、目標設定力、モデリング効果、ストレスマネジメント、コーピング
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑦率先的に行動するスキル'}
                                        duration={'24:19'}
                                        imageUrl={img8}
                                        urlContent={'https://player.aircamp.us/content/57187?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 率先的に行動するには、自分で自分を動機づけていくことが必要になる。動機づけのキーワードは「エンゲージメント」。この講義では、欠乏動機と内的報酬による動機づけについて解説し、エンゲージメントを高める方法を解説する。
                                    <br/><br/>キーワード：エンゲージメント、ジョブクラフティング、内的報酬
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑧明快に説明するスキル'}
                                        duration={'24:19'}
                                        imageUrl={img9}
                                        urlContent={'https://player.aircamp.us/content/57188?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> われわれ日本人は、人の話を聞くことより自分の考えを伝える方が苦手と言われています。この講義では明快に説明するテンプレートである「ＤＥＳＣ法」を解説したあと会合の種類、ブレーンストーミングの手法について解説します。
                                    <br/><br/>キーワード：DESC法、メラビアンの法則
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑨アンラーニングするスキル'}
                                        duration={'24:19'}
                                        imageUrl={img10}
                                        urlContent={'https://player.aircamp.us/content/57189?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> アンラーニングとは、これまでに学習してきた知識や構築してきた理論を棚卸しして、意識的に棄却することです。誤った知識や古い概念を残したままではラーニング効率が低下するため、アンラーニングとラーニングのサイクルをどんどん回すことが重要です。本講座ではアンラーニングだけでなく、誤学習、未学習、古学習（時代に合わなくなった慣習など）についても解説します。
                                    <br/><br/>キーワード：アンラーニング
                                </td>
                            </tr>
                            <tr>
                                <td className={'p-3'}>
                                    <VideoSectionComponent
                                        title={'⑩新しいことにチャレンジするス キル'}
                                        duration={'24:19'}
                                        imageUrl={img1}
                                        urlContent={'https://player.aircamp.us/content/57190?token=4fdec9c2ab6a2ad8'}
                                    />
                                </td>
                                <td className={'data-description'}> 新たなことに挑戦するには創造的思考が欠かせません。<br/>
                                    目などの感覚器から大脳に入った情報そのままで深掘りをしない直感的思考と、情報の比較や分析等の操作でより効果的に活用する操作的（論理的）思考。これらを理解して矛盾する論理が少しでも肯定に近づく対策案を考えることで、おのずと創造性は培われます。
                                    <br/><br/>キーワード：創造的思考、操作的思考、形式的操作
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    }
                </div>
            </Element>

        </>
    );
}

export default RecommendTable;
